import { Dialog, DialogBody, DialogTitle } from "V2.0/common/dialog";
import { EndCallTriggerForm } from "./EndCallTriggerForm";

function EndCallTriggerEdit({ endCallTrigger, open, onClose, onTriggerEdit }) {

  return (
      <Dialog
        className=""
        size="xl"
        open={open}
        onClose={onClose}
      >
        <DialogTitle>
          <p className="text-lg">
            Edit End Call Trigger
          </p>
        </DialogTitle>
        <DialogBody className="text-sm/6">
          <EndCallTriggerForm
            endCallTrigger={endCallTrigger}
            onCancel={onClose}
            onSubmit={onTriggerEdit}
          />
        </DialogBody>
      </Dialog>
  );
}

export { EndCallTriggerEdit };
